import React from 'react';
import { Box } from '@mui/material';
import { useToggleModal } from '@hooks';
import { ModalFormSection, ModalV2 } from 'components/common/modals';
import { showError } from '@utils';
import { videosServices } from '@services';

import VideoForm from '../VideoForm/VideoForm';
import { DeleteConfirmationVideoModal } from './DeleteConfirmationVideoModal';

const styles = {
  wrapper: {
    borderRadius: '8px',
    padding: '16px',
    minWidth: '268px',
    maxWidth: '305px',
    flex: 1,
    border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
  },
};

export const VideosListItem = ({ data, onGetVideos }) => {
  const { isOpen, handleOpen, handleClose } = useToggleModal();
  const {
    isOpen: isOpenDeleteConfirmation,
    handleOpen: handleOpenDeleteConfirmation,
    handleClose: handleCloseDeleteConfirmation,
  } = useToggleModal();

  const handleSubmit = async (values) => {
    try {
      await videosServices.updateVideo(data.id, values);
      handleClose();
      onGetVideos();
    } catch (e) {
      showError(e);
    }
  };

  const handleDelete = async () => {
    try {
      await videosServices.deleteVideo(data.id);
      handleCloseDeleteConfirmation();
      onGetVideos();
    } catch (e) {
      showError(e);
    }
  };

  return (
    <Box sx={styles.wrapper}>
      <VideoForm
        defaultValues={data}
        isFieldsEditable={false}
        onEdit={handleOpen}
        onDelete={handleOpenDeleteConfirmation}
      />
      {isOpen && (
        <ModalV2
          id={`edit=${data.id}`}
          title="Edit video"
          isOpen={isOpen}
          onClose={handleClose}
          maxWidth="sm"
        >
          <ModalFormSection>
            <VideoForm
              defaultValues={data}
              isEditable
              onEdit={handleOpen}
              onSubmit={handleSubmit}
            />
          </ModalFormSection>
        </ModalV2>
      )}
      {isOpenDeleteConfirmation && (
        <DeleteConfirmationVideoModal
          isOpen={isOpenDeleteConfirmation}
          onClose={handleCloseDeleteConfirmation}
          onConfirm={handleDelete}
        />
      )}
    </Box>
  );
};

export default VideosListItem;
